module.exports = __webpack_public_path__ + "static/media/courses-icon.8997d1f9.svg";